import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarDays, MapPin, ArrowRight, Sparkles } from "lucide-react";

const EventBanner = () => {
  return (
    <section id="event" data-testid="home-event-banner" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-[#0B1B3D] px-8 sm:px-14 py-12 sm:py-16">
          {/* subtle texture */}
          <div className="absolute inset-0 bg-grid-navy opacity-[0.15]" />
          <div className="absolute -right-24 -top-24 w-80 h-80 rounded-full bg-[#D91C29]/20 blur-3xl" />

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative z-10 max-w-3xl"
          >
            <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs uppercase tracking-widest text-white/90 font-medium">
              <Sparkles size={13} className="text-[#D91C29]" />
              Upcoming Panel Discussion
            </span>

            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mt-6 leading-tight">
              Terms of Trade: India, Britain, and the Long Shadow of Empire
            </h2>
            <p className="mt-5 text-lg text-slate-300 leading-relaxed">
              India just signed a trade deal with Britain. Is this a partnership — or a familiar pattern?
            </p>

            <div className="mt-7 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
              <div className="flex items-center gap-3 text-slate-200">
                <CalendarDays size={18} className="text-[#D91C29]" />
                <span className="text-sm font-medium">July 17, 2026 · 10:00 AM – 4:00 PM</span>
              </div>
              <div className="flex items-center gap-3 text-slate-200">
                <MapPin size={18} className="text-[#D91C29]" />
                <span className="text-sm font-medium">India Habitat Centre, New Delhi</span>
              </div>
            </div>

            <Link
              to="/event"
              data-testid="home-event-cta"
              className="group mt-9 inline-flex items-center gap-2 rounded-full bg-[#D91C29] text-white font-semibold px-7 py-3.5 shadow-lg hover:bg-[#b3141f] hover:-translate-y-0.5 transition-transform transition-colors duration-200 w-fit"
            >
              RSVP to join the discussion
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default EventBanner;
